import { ComponentInfoEffects } from './component-info/component-info.effects';
import { ProviderEffects } from './provider/provider.effects';
import { LoggedInUserEffects } from './logged-in-user/logged-in-user.effects';

export const sharedEffects = [ComponentInfoEffects, ProviderEffects, LoggedInUserEffects];
